import { UserPaymentDetailsFormContentBankAccountDetailsProps } from './props';
import UserPaymentDetailsFormContentBankAccountDetailsMexicanBankAccount from './MexicanBankAccount';
import UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccount from './ArgentineBankAccount';
import { UserPaymentDetailsTypeId } from '../../../../../../../../../../enums';
import { useCoallescedUserPaymentTypeId } from '../../../../../../../../../../hooks';
import UserPaymentDetailsFormContentBankAccountDetailsNigerianBankAccount from './NigerianBankAccount';

/**
 * UserPaymentDetailsFormContentBankAccountDetails Component
 * This component is responsible for rendering the specific bank account details component
 * based on the user's payment type ID. It selects the appropriate component to display
 * based on the type of bank account.
 *
 * @param {UserPaymentDetailsFormContentBankAccountDetailsProps} props - The properties for the component.
 * @param {UserPaymentDetailsValidationResult} props.validationResult - The validation result for the bank account details.
 *
 * @returns {JSX.Element | null} The rendered component for the specific bank account details or null if no match is found.
 *
 * @example
 * // Usage example:
 * <UserPaymentDetailsFormContentBankAccountDetails validationResult={validationResult} />
 */
export default function UserPaymentDetailsFormContentBankAccountDetails({
  validationResult,
}: UserPaymentDetailsFormContentBankAccountDetailsProps) {
  // Retrieve the coalesced user payment type ID
  const typeId: string = useCoallescedUserPaymentTypeId();

  // Render the appropriate bank account details component based on the type ID
  switch (typeId) {
    case UserPaymentDetailsTypeId.MexicanBankAccount?.toString():
      return (
        <UserPaymentDetailsFormContentBankAccountDetailsMexicanBankAccount
          validationResult={validationResult}
        />
      );
    case UserPaymentDetailsTypeId.ArgentineBankAccount?.toString():
      return (
        <UserPaymentDetailsFormContentBankAccountDetailsArgentineBankAccount
          validationResult={validationResult}
        />
      );
    case UserPaymentDetailsTypeId.NigerianBankAccount?.toString():
    case UserPaymentDetailsTypeId.SingaporeBankAccount?.toString():
    case UserPaymentDetailsTypeId.SouthAfricaBankAccount?.toString():
      return (
        <UserPaymentDetailsFormContentBankAccountDetailsNigerianBankAccount
          validationResult={validationResult}
        />
      );
    default:
      // Return null if no matching type ID is found
      return null;
  }
}
